import axios from "axios";
import Swal from "sweetalert2";
import {
  baseUrl,
  defaultAddErrorMessage,
  defaultUpdateErrorMessage,
  errorTranslate,
  objectifyForDropdown,
} from "../util";

export const addCompFinalTreatmentOwnToBusiness = ({
  businessId,
  product_name,
  treatment_country,
  end_of_life_strategy,
  total_weight_treated,
  category,
  price_invoice,
  is_disassembly,
  is_leased_take_back,
  invoice_date,
  invoice_number,
  product_component,
  loading = null,
  setLoading = null,
  index,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    product_name: product_name,
    treatment_country: treatment_country,
    end_of_life_strategy: end_of_life_strategy,
    total_weight_treated: total_weight_treated,
    category: category,
    price_invoice: price_invoice || null,
    is_disassembly: is_disassembly,
    is_leased_take_back: is_leased_take_back,
    invoice_date: invoice_date || null,
    invoice_number: invoice_number || null,
    product_component: product_component || null,
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/business/" + businessId + "/comp-final-treatment-own",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};

export const deleteCompFinalTreatmentOwn = ({
  businessId,
  objectId,
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
}) => {
  var config = {
    method: "delete",
    url:
      baseUrl +
      "/api/business/" +
      businessId +
      "/comp-final-treatment-own/" +
      objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const getCompFinalTreatmentOwnList = ({
  businessId,
  objectId,
  objects,
  setObjects,
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/comp-final-treatment-own",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(
        response.data.data.map((data) => {
          data.end_of_life_strategy = objectifyForDropdown(
            data.end_of_life_strategy
          );
          data.treatment_country = objectifyForDropdown(data.treatment_country);
          data.is_disassembly = data.is_disassembly ? "Yes" : "No";
          data.is_leased_take_back = data.is_leased_take_back ? "Yes" : "No";
          return data;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateCompFinalTreatmentOwn = ({
  businessId,
  objectId,
  product_name,
  treatment_country,
  end_of_life_strategy,
  total_weight_treated,
  category,
  price_invoice,
  is_disassembly,
  is_leased_take_back,
  invoice_date,
  invoice_number,
  product_component,
  objects,
  setObjects = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    product_name: product_name,
    treatment_country: treatment_country,
    end_of_life_strategy: end_of_life_strategy,
    total_weight_treated: total_weight_treated,
    category: category,
    price_invoice: price_invoice || null,
    is_disassembly: is_disassembly,
    is_leased_take_back: is_leased_take_back,
    invoice_date: invoice_date || null,
    invoice_number: invoice_number || null,
    product_component: product_component || null,
  });

  var config = {
    method: "put",
    url:
      baseUrl +
      "/api/business/" +
      businessId +
      "/comp-final-treatment-own/" +
      objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((supply) => {
          if (response.data.data.id === supply.id) {
            response.data.data.end_of_life_strategy = objectifyForDropdown(
              response.data.data.end_of_life_strategy
            );
            response.data.data.treatment_country = objectifyForDropdown(
              response.data.data.treatment_country
            );
            response.data.data.is_disassembly = response.data.data
              .is_disassembly
              ? "Yes"
              : "No";
            response.data.data.is_leased_take_back = response.data.data
              .is_leased_take_back
              ? "Yes"
              : "No";
            return response.data.data;
          }
          return supply;
        })
      );
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");

      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultUpdateErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      setErrorMessage(error.response.data);
    });
};

export const getCompFinalTreatmentOwn = ({
  businessId,
  objectId,
  objects,
  setObjects,
}) => {
  var config = {
    method: "get",
    url:
      baseUrl +
      "/api/business/" +
      businessId +
      "/comp-final-treatment-own/" +
      objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((supply) => {
          const gotValue = response.data.data;

          if (gotValue.id === supply.id) {
            gotValue.end_of_life_strategy = objectifyForDropdown(
              gotValue.end_of_life_strategy
            );
            gotValue.treatment_country = objectifyForDropdown(
              gotValue.treatment_country
            );
            gotValue.is_disassembly = gotValue.is_disassembly ? "Yes" : "No";
            gotValue.is_leased_take_back = gotValue.is_leased_take_back
              ? "Yes"
              : "No";

            return gotValue;
          }
          return supply;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};
